import { render, staticRenderFns } from "./evaluationCenter.vue?vue&type=template&id=5c1442dc&scoped=true&"
import script from "./evaluationCenter.vue?vue&type=script&lang=js&"
export * from "./evaluationCenter.vue?vue&type=script&lang=js&"
import style0 from "./evaluationCenter.vue?vue&type=style&index=0&id=5c1442dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1442dc",
  null
  
)

export default component.exports